import styled from "styled-components"
export const FooterStyled = styled.div`
  width: 336px;
  position: relative;
`

export const Wrapper = styled.div<{ footerState: boolean; height?: string }>`
  display: ${({ footerState }) => (footerState ? "block" : "none")};
  height: ${({ height }) => height};
  width: 336px;
  padding: 15px;
  border-radius: 0 0 20px 20px;
  background: rgba(48, 30, 86, 0.85);

  span {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    font-size: 13px;
  }
  /* section {
    display: flex;
    justify-content: space-between;
  } */
  p {
    text-align: center;
    font-style: normal;
    font-weight: 700;
    font-size: 10px;
    line-height: 13px;
    color: #766599;
    margin-top: 5px;
  }
`
